import gql from "graphql-tag";

export const GET_CURRENCIES = gql`
  query {
    currencies {
      id
      name
    }
  }
`;

export const ADD_CURRENCY = gql`
  mutation AddCurrency($name: String!) {
    addCurrency(name: $name) {
      id
      name
    }
  }
`;

export const UPDATE_CURRENCY = gql`
  mutation UpdateCurrency($id: ID!, $name: String!) {
    updateCurrency(id: $id, name: $name) {
      id
      name
    }
  }
`;

export const DELETE_CURRENCY = gql`
  mutation DeleteCurrency($id: ID!) {
    deleteCurrency(id: $id)
  }
`;
